const isiOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent) && !window.MSStream;
const isWebView = /;\swv\)/.test(window.navigator.userAgent) && !/OPR/g.test(window.navigator.userAgent);
const isIosWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Version)/i.test(window.navigator.userAgent) && !/OPiOS/g.test(window.navigator.userAgent);
const isFBApp = /FBAV/i.test(window.navigator.userAgent);
const isOperaMini = /Opera/g.test(window.navigator.userAgent) || /OPiOS/.test(window.navigator.userAgent) || /OPR\//.test(window.navigator.userAgent);
const isIosChrome = /(iPhone|iPad).*CriOS/.test(window.navigator.userAgent);
const isMiuiBrowser = /MiuiBrowser/.test(window.navigator.userAgent);

export {
    isiOS,
    isWebView,
    isIosWebView,
    isFBApp,
    isOperaMini,
    isIosChrome,
    isMiuiBrowser,
}

export default {
    isiOS,
    isWebView,
    isIosWebView,
    isFBApp,
    isOperaMini,
    isIosChrome,
    isMiuiBrowser,
}
